"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var _typesafeActions = require("typesafe-actions");

var _moment = _interopRequireDefault(require("moment"));

var _reactRouterDom = require("react-router-dom");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _goals = require("../../../redux/goals/goals.types");

require("./goal.scss");

var _api = require("../../../redux/api/api.types");

var _topic = require("../../../redux/topics/topic.types");

var _Util = require("../../../components/util/Util");

var _Username = _interopRequireDefault(require("../../../components/username/Username"));

var _UnsavedLeavingGuard = _interopRequireDefault(require("../../../components/util/UnsavedLeavingGuard"));

var _GoalForm = _interopRequireDefault(require("../../../components/goalSetting/GoalForm"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Column
} = _table.default;
const {
  Search
} = _input.default;

class GoalSettingList extends _react.Component {
  constructor(props) {
    super(props);
    this.debouncedSearch = undefined;

    this.rowClassName = (record, index) => index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';

    this.onAddGoalClicked = () => {
      const {
        studyId,
        history
      } = this.props;
      history.push(`/study/${studyId}/goals/new`);
    };

    this.closeForm = () => {
      const {
        studyId,
        history
      } = this.props;
      history.push(`/study/${studyId}/goals/`);
    };

    this.onQueryChange = e => {
      this.props.updateGoalUIState({ ...this.props.goalUIState,
        query: e.target.value
      });

      if (e.target.value.length === 0) {
        this.debouncedSearch = undefined;
      }
    };

    this.onSearch = () => {
      // TODO: have someone review this implementation of debounce (specifically, the isNewSearch logic)
      if (!this.debouncedSearch) {
        this.debouncedSearch = _.debounce(() => {
          this.reinitializeAndSearch(true);
        }, 600);
      } else {
        this.debouncedSearch = _.debounce(() => {
          this.reinitializeAndSearch(false);
        }, 600);
      }

      this.debouncedSearch();
    };

    this.reinitializeAndSearch = isNewSearch => {
      const {
        loadGoals,
        clearGoals,
        goalUIState
      } = this.props;
      const {
        query,
        pageNumber,
        pageSize
      } = goalUIState;

      if (isNewSearch) {
        clearGoals();
      }

      loadGoals({
        query,
        pageNumber,
        pageSize
      });
    };

    this.handleRowClick = record => {
      const {
        studyId,
        history
      } = this.props;

      if (record && record.id) {
        history.push(`/study/${studyId}/goals/${record.id}`);
      }
    };

    this.renderTopic = topicId => {
      const {
        topics
      } = this.props;

      if (!topics) {
        return 'UNKNOWN';
      }

      for (const topic of topics) {
        if (topic.id === topicId) {
          return topic.title;
        }

        if (topic.children && topic.children.length > 0) {
          for (const child of topic.children) {
            if (child.id === topicId) {
              return `${topic.title} : ${child.title}`;
            }
          }
        }
      }
    };

    this.renderParticipant = participantId => {
      return /*#__PURE__*/_react.default.createElement(_Username.default, {
        participantId: participantId
      });
    };

    this.dateSorter = (a, b) => {
      if (!a && !b) return 0;
      if (a === undefined) return -1;
      if (b === undefined) return 1;
      if (a === null) return -1;
      if (b === null) return 1;
      return (0, _moment.default)(a).unix() - (0, _moment.default)(b).unix();
    };

    this.createDateSorter = (a, b) => this.dateSorter(a.createDate, b.createDate);

    this.publishDateSorter = (a, b) => this.dateSorter(a.publishDate, b.publishDate);

    this.lastUpdateDateSorter = (a, b) => this.dateSorter(a.lastUpdateDate, b.lastUpdateDate);

    this.deleteDateSorter = (a, b) => this.dateSorter(a.deleteDate, b.deleteDate);

    this.onTopicFilter = (value, record) => {
      return record.topicId === value;
    };

    this.titleSorter = (a, b) => {
      return a.title.localeCompare(b.title);
    };

    this.onUnsavedChange = isUnsaved => {
      this.setState({
        isUnsaved
      });
    };

    this.copyDeepLink = id => {
      const deepLink = `hmp://goal/${id}`;
      navigator.clipboard.writeText(deepLink).then(() => {
        _message2.default.success('Copied to clipboard!');
      }, () => {
        _message2.default.error('Failed to copy to clipboard.');
      });
    };

    this.renderActions = goal => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "goal-action-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Copy deep link to clipboard",
        className: "goal-action",
        onClick: e => {
          e.stopPropagation();
          this.copyDeepLink(goal.id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-link"
      })));
    };

    this.state = {
      isUnsaved: false
    };
  }

  async componentDidMount() {
    const {
      loadGoals,
      loadGoalTopics,
      goalUIState
    } = this.props;
    const {
      query,
      pageNumber,
      pageSize
    } = goalUIState;
    await loadGoalTopics();
    await loadGoals({
      query,
      pageNumber,
      pageSize
    });
  }

  componentDidUpdate(prevProps) {
    const {
      createGoalStatus,
      updateGoalStatus,
      clearLoadStatus,
      deleteGoalStatus
    } = this.props;
    const {
      createGoalStatus: prevCreateStatus,
      updateGoalStatus: prevUpdateStatus,
      deleteGoalStatus: prevDeleteStatus
    } = prevProps;

    if (!prevCreateStatus.isError && createGoalStatus.isError || !prevUpdateStatus.isError && updateGoalStatus.isError) {
      _message2.default.error('Error saving goal.');

      clearLoadStatus((0, _typesafeActions.getType)(_goals.createGoalAsync.failure));
      clearLoadStatus((0, _typesafeActions.getType)(_goals.updateGoalAsync.failure));
    }

    if (!prevCreateStatus.isSuccess && createGoalStatus.isSuccess) {
      _message2.default.success('Goal successfully saved.');

      clearLoadStatus((0, _typesafeActions.getType)(_goals.createGoalAsync.success));
    }

    if (!prevUpdateStatus.isSuccess && updateGoalStatus.isSuccess) {
      _message2.default.success('Goal successfully updated.');

      clearLoadStatus((0, _typesafeActions.getType)(_goals.updateGoalAsync.success));
    }

    if (!prevDeleteStatus.isSuccess && deleteGoalStatus.isSuccess) {
      _message2.default.success('Goal successfully deleted.');

      clearLoadStatus((0, _typesafeActions.getType)(_goals.deleteGoalAsync.success));
    }

    if (!prevDeleteStatus.isError && deleteGoalStatus.isError) {
      _message2.default.error('Error deleting goal.');

      clearLoadStatus((0, _typesafeActions.getType)(_goals.deleteGoalAsync.failure));
    } // If search is cleared, clear goals in redux state and reload


    if (prevProps.goalUIState.query && prevProps.goalUIState.query.length > 0 && this.props.goalUIState.query && this.props.goalUIState.query.length === 0) {
      this.props.clearGoals();
      this.props.loadGoals(this.props.goalUIState);
    }
  }

  render() {
    var _a;

    const {
      goals,
      requestedGoalId,
      goalUIState
    } = this.props;
    const {
      isUnsaved
    } = this.state;
    const {
      query
    } = goalUIState;
    const topicFilters = (_a = this.props.topics) === null || _a === void 0 ? void 0 : _a.map(t => {
      return {
        text: t.title,
        value: t.id
      };
    });
    const viewForm = requestedGoalId && requestedGoalId.length > 0;
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "goal-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Goals"), /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this.onAddGoalClicked
      }, "+ Add Goal"))
    }, viewForm && /*#__PURE__*/_react.default.createElement(_GoalForm.default, {
      key: `goal-form-${requestedGoalId}`,
      visible: viewForm,
      closeHandler: this.closeForm,
      onUnsavedChange: this.onUnsavedChange
    }), /*#__PURE__*/_react.default.createElement(Search, {
      placeholder: "Search text",
      allowClear: true,
      onChange: this.onQueryChange,
      onSearch: this.onSearch,
      enterButton: true,
      value: query,
      style: {
        width: 200,
        marginBottom: '10px'
      }
    }), /*#__PURE__*/_react.default.createElement(_table.default, {
      dataSource: goals,
      rowKey: "id",
      rowClassName: `${this.rowClassName} goal-table-row`,
      scroll: {
        y: 500
      },
      pagination: false,
      onRow: (record, rowIndex) => {
        return {
          onClick: event => this.handleRowClick(record),
          onDoubleClick: event => {},
          onContextMenu: event => {},
          onMouseEnter: event => {},
          onMouseLeave: event => {} // mouse leave row

        };
      }
    }, /*#__PURE__*/_react.default.createElement(Column, {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: this.titleSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Participant",
      dataIndex: "participantId",
      key: "participantId",
      render: this.renderParticipant
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Description",
      dataIndex: "description",
      key: "description"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Topic",
      dataIndex: "topicId",
      key: "topicId",
      render: this.renderTopic,
      filters: topicFilters,
      onFilter: this.onTopicFilter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: _Util.renderDateCalendar,
      sorter: this.createDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Last Update Date",
      dataIndex: "lastUpdateDate",
      key: "lastUpdateDate",
      render: _Util.renderDateCalendar,
      sorter: this.lastUpdateDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Delete Date",
      dataIndex: "deleteDate",
      key: "deleteDate",
      render: _Util.renderDateCalendar,
      sorter: this.deleteDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Publish Date",
      dataIndex: "publishDate",
      key: "publishDate",
      render: _Util.renderDateCalendar,
      sorter: this.publishDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Actions",
      render: this.renderActions
    })), /*#__PURE__*/_react.default.createElement(_UnsavedLeavingGuard.default, {
      when: isUnsaved,
      navigate: path => this.props.history.push(path),
      shouldBlockNavigation: () => isUnsaved
    }));
  }

}

const mapStateToProps = state => {
  return {
    studyId: selectors.getRequestedStudyId(state),
    requestedGoalId: selectors.getRequestedEditGoalId(state),
    goalUIState: selectors.selectGoalUIState(state),
    goals: selectors.getGoals(state),
    topics: selectors.getGoalTopics(state),
    loadGoalsStatus: selectors.loadGoalsStatus(state),
    createGoalStatus: selectors.createGoalStatus(state),
    updateGoalStatus: selectors.updateGoalStatus(state),
    deleteGoalStatus: selectors.deleteGoalStatus(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadGoals: args => dispatch(_goals.getGoalsAsync.request(args)),
    clearLoadStatus: type => dispatch((0, _api.clearStatus)(type)),
    clearGoals: () => dispatch((0, _goals.clearGoals)()),
    loadGoalTopics: () => dispatch(_topic.loadGoalTopicsAsync.request()),
    updateGoalUIState: args => dispatch((0, _goals.updateGoalsUIState)(args))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(GoalSettingList));

exports.default = _default;